<template>
  <Section class="paginated-articles" wide-mode small-space>
    <h2 class="title">Articles dans {{ childCategoryTitle }}</h2>
    <div class="articles">
      <template v-for="article in paginatedArticles.data" :key="article.id">
        <article-card :article="article" :parent-category-slug="parentCategorySlug" large />
      </template>
    </div>
    <OldPagination v-if="totalPages > 1" :pages="totalPages" :modelValue="currentPage">
      <template v-slot:prevPage="{ page }">
        <NuxtLink :to="formatPagePath(page)">
          <div>&lt;</div>
        </NuxtLink>
      </template>
      <template v-slot:page="{ page }">
        <NuxtLink :to="formatPagePath(page)">
          <div>{{ page }}</div>
        </NuxtLink>
      </template>
      <template v-slot:nextPage="{ page }">
        <NuxtLink :to="formatPagePath(page)">
          <div>&gt;</div>
        </NuxtLink>
      </template>
    </OldPagination>
  </Section>
</template>

<script>
export default {
  props: {
    paginatedArticles: {
      type: Object,
      required: true,
    },
    parentCategorySlug: {
      type: String,
      required: true,
    },
    childCategoryTitle: {
      type: String,
      required: true,
    },
    childCategorySlug: {
      type: String,
      required: true,
    },
  },
  computed: {
    totalPages() {
      return this.paginatedArticles.pagination.pageCount
    },
    currentPage() {
      return this.paginatedArticles.pagination.page
    },
  },
  methods: {
    formatPagePath(page) {
      return page === 1
        ? `/${this.parentCategorySlug}/${this.childCategorySlug}`
        : `/${this.parentCategorySlug}/${this.childCategorySlug}/page/${page}`
    },
  },
}
</script>

<style lang="less" scoped>
.title {
  font-weight: var(--ds-weight-semi-bold);
  font-size: 24px;
  color: var(--ds-color-primary-100);
  margin-bottom: 24px;
}

:deep(.article-card) {
  margin-bottom: 24px;
}

@media @bp-desktop {
  .articles {
    display: grid;
    align-items: center;
    justify-items: center;
    place-items: center;
    grid-column-gap: 32px;
    -moz-column-gap: 32px;
    column-gap: 32px;
    grid-row-gap: 60px;
    row-gap: 60px;
    grid-template-columns: repeat(auto-fit, 260px);
    justify-content: space-evenly;
    margin-bottom: 48px;
  }

  :deep(.article-card) {
    margin-bottom: 0;
  }
}
</style>
